import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Pipe({
  standalone: true,
  name: 'DateTimeFormatPipe'
})
export class DateTimeFormatPipe implements PipeTransform {
  constructor(private companyConfig: ConfigurationService,) {

  }
  transform(value: Date, transform: string = ""): string {
    switch (transform) {
      case 'dateonly':
        return this.companyConfig.formatDateLocaleByCountry(value);
      case 'timeonly':
        return this.companyConfig.formatTimeLocaleByCountry(value);
      case 'datetime':
      default:
        return this.companyConfig.formatDateTimeLocaleByCountry(value);
    }
  }
}
